// extracted by mini-css-extract-plugin
export default {"main":"TwelvedataGrowthEstimates_main__NHQ+L"};